import { createFileRoute, redirect } from '@tanstack/react-router';

/** Catch-all: qualquer rota desconhecida cai no dashboard (que por sua vez exige login). */
export const Route = createFileRoute('/$')({
  beforeLoad: () => {
    return redirect({ to: '/dashboard' });
  },
});
